// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import Loading from 'react-loading';
import CreatableSelect from 'react-select/creatable';

import Modal from './Modal';
import Checkbox from '../Checkbox';

import api from '../../api';

import '../../styles/modal.css';
import { toast } from 'react-toastify';

export default class SendDocument extends Modal {

    state = {
        emails: [],
        inputEmail: "",
        message: "",
        password: "",
        addressBook: {
            emails: []
        },
        method: "public",
        sending: false
    }

    componentDidMount = async () => {
        const res = await api.get('/team/contacts/emails');
        if (!res || !res.emails)
            return;
        this.setState({
            addressBook: {
                ...this.state.addressBook,
                emails: res.emails
            }
        });

        if (this.props.data && this.props.data.fillable && this.props.data.fillable.enabled)
            this.setState({ method: "form" });
    }

    renderContent = () => {

        const users = this.props.team && this.props.team.users ? this.props.team.users : [];
        const doc = this.props.data;
        const replyTo = doc && doc.source && doc.source.substring(0,6) === "Email:" ? doc.source.substring(7) : "";

        const fillable = doc.fillable && doc.fillable.enabled;

        return (<div className="modal-content modal-center">
            
            <br />
            <h1>Share this document</h1>

            <p>
                You can assign this document to a team member or tag them in a comment to share it with them.
            </p>
            <p>
                If you'd like to share it with someone outside your Stax·ai team account, you can make this public, password-protected, or send (documents smaller than 25 MB) as an email attachment.
            </p><br />

            <div className="form-line form-line-long">
                <label>Send to</label>
                <div style={{
                    float: 'left',
                    width: '100%',
                    position: 'relative'
                }}>
                    <CreatableSelect
                        components={{ DropdownIndicator: null }}
                        className="multi-select-container"
                        classNamePrefix="multi-select"
                        placeholder="Recipient emails..."
                        isMulti
                        options={users.map(user => ({
                            value: user.email,
                            label: user.name
                        })).concat(this.state.addressBook.emails.filter(email => !users.some(user => user.email === email)).map(email => ({
                            value: email,
                            label: email
                        })))}
                        defaultMenuIsOpen={false}
                        
                        onChange={(value) => {
                            this.setState({
                                emails: value ? value.map(user => user.value) : []
                            });
                        }}
                        value={this.state.emails.map(email => ({
                            label: email,
                            value: email
                        }))}

                        onInputChange={(value) => {

                            if (this.state.inputEmail.length > 2 && value === "")
                                this.setState({
                                    emails: [
                                        ...this.state.emails,
                                        this.state.inputEmail
                                    ],
                                    inputEmail: ""
                                });

                            else if (value !== "" || this.state.inputEmail.length === 1)
                                this.setState({
                                    inputEmail: value
                                });

                        }}
                        inputValue={this.state.inputEmail}

                    />
                    {replyTo !== "" && !this.state.emails.includes(replyTo) ? <div className="modal-select-button" onClick={() => this.setState({
                        emails: [ ...this.state.emails, replyTo ]
                    })}>Reply</div> : ""}
                </div>
            </div>

            <div className="form-line form-line-long">
                <label>Send as</label>
                <div className="modal-checkbox-inline-container">
                    <div className="modal-checkbox-inline-4">
                        <Checkbox
                            label="Public Link"
                            checked={this.state.method === "public"}
                            onToggle={() => this.setState({ method: "public" })}
                        />
                    </div>
                    <div className="modal-checkbox-inline-4">
                        <Checkbox
                            label="Secured Link"
                            checked={this.state.method === "password"}
                            onToggle={() => this.setState({ method: "password" })}
                        />
                    </div>
                    <div className="modal-checkbox-inline-4">
                        <Checkbox
                            label="Attachment"
                            checked={this.state.method === "attachment"}
                            onToggle={() => this.setState({ method: "attachment" })}
                        />
                    </div>
                    <div className="modal-checkbox-inline-4">
                        <Checkbox
                            label="Fillable Form"
                            checked={this.state.method === "form"}
                            onToggle={() => this.setState({ method: "form" })}
                            disabled={!fillable}
                            tooltip={fillable ? "The recipient can fill and sign the document. The completed version will be saved as a new document." : "To allow the recipients to fill and sign this document, go the the document actions and click on: Configure Inputs"}
                        />
                    </div>
                </div>
            </div>

            {this.state.method === "password" && <div className="form-line form-line-long">
                <label>Password</label>
                <div style={{
                    float: 'right',
                    width: 520,
                    marginRight: 5,
                    marginBottom: -25
                }}>
                    <input
                        type="password"
                        className="modal-password"
                        placeholder="Enter a secret word or phrase..."
                        value={this.state.password}
                        onChange={e => this.setState({ password: e.target.value })}
                    />
                </div>
            </div>}

            <div className="form-line form-line-long">
                <label>Message</label>
                <textarea
                    placeholder="(Optional) What is this document about? Should they do something with it? Does it need to be sent back?"
                    onChange={(e) => this.setState({
                        message: e.target.value
                    })}
                    value={this.state.message}
                    style={{
                        float: 'left',
                        width: "calc(100% - 24px)"
                    }}
                >
                </textarea>
            </div>

            <div style={{
                clear: 'both',
                height: 20
            }} />

            {this.state.sending ? <div
                style={{
                    width: 80,
                    margin: "0 auto",
                    marginTop: -10
                }}
            >
                <Loading
                    type="bubbles"
                    color="var(--color-primary-dark)"
                    height={80}
                    width={80}
                />
            </div> : (this.state.emails.length && (this.state.method !== "password" || this.state.password.length > 5)) > 0 ? <div
                className="button"
                style={{
                    float: 'none',
                    backgroundImage: "url('https://static.stax.ai/images/icons/send.png')"
                }}
                onClick={async () => {
                    await this.setState({ sending: true });

                    const res = await api.post('/document/send', {
                        docId: doc._id,
                        recipients: this.state.emails,
                        method: this.state.method,
                        password: this.state.password,
                        message: this.state.message !== "" ? this.state.message : null
                    });

                    await this.setState({ sending: false });

                    if (!res || !res.success)
                        return toast.error("Error sending document!");

                    toast.success("Successfully sent document!");
                    await this.setState({ emails: [], message: "" });
                    this.props.modal();
                }}
            >Share document</div> : ""}

        </div>);
    }

};